module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"ui":{"components":{"base":{"ais":{"clear_refinements":{"label":"Clear Filters"}}}}}}}')
  delete Component.options._Ctor
}
